import { dateFormat } from '../../../../modules/Utils'
import moment from 'moment'
import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button, Tag } from 'antd'

function List(props) {
  const { list, fetch, fetching, onShow } = props

  const display = (value, original, accessor) =>
    original.type === accessor && original.isAllDay ? <Tag color="#2db7f5">ALL DAY</Tag> : value

  const columns = [
    { Header: 'ID', accessor: '_id', hideable: true, hideDefault: true },
    {
      Header: 'Day',
      accessor: 'day',
      Cell: ({ value, original }) => (
        <a onClick={() => onShow(original, 'edit')}>{dateFormat(moment(value), 'DD MMM (ddd)')}</a>
      ),
    },
    {
      Header: 'Office',
      accessor: 'office',
      Cell: ({ value, original }) => display(value, original, 'office'),
    },
    {
      Header: 'Home',
      accessor: 'home',
      Cell: ({ value, original }) => display(value, original, 'home'),
    },
    {
      Header: 'Site',
      accessor: 'site',
      Cell: ({ value, original }) => display(value, original, 'site'),
    },
    {
      Header: 'Over Time',
      accessor: 'over-time',
      Cell: ({ value, original }) => display(value, original, 'over-time'),
    },
    {
      Header: 'Travel Day',
      accessor: 'travel-day',
      Cell: ({ value, original }) => display(value, original, 'travel-day'),
    },
    {
      Header: 'Rostered Day',
      accessor: 'rostered-day',
      Cell: ({ value, original }) => display(value, original, 'rostered-day'),
    },
    {
      Header: 'Public Holiday',
      accessor: 'public-holiday',
      Cell: ({ value, original }) => display(value, original, 'public-holiday'),
    },
  ]

  return (
    <CustomTable
      data={list}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          Add Day Timesheet
        </Button>
      )}
      columns={columns}
      defaultSorted={[
        {
          id: 'day',
          desc: false,
        },
      ]}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
